import React, { useState } from 'react';
import style from '../../css/Pop.module.css';
import {
	FaBars,
	FaTimes,
	FaEnvelope,
	FaPhoneAlt,
	FaWhatsapp,
	FaChevronRight,
} from 'react-icons/fa';

function Pop() {
	const [show, setShow] = useState(false);
	const [showCon, setShowCon] = useState(true);

	return (
		<div className={style.container}>
			{show === true ? (
				<div className={style.iconColom}>
					<a className={style.a} href="https://wa.me/+91%208884264377">
						<FaWhatsapp className={style.icon} />
					</a>
					<a className={style.a} href="mailto:kanasucyber128@gmail.com">
						<FaEnvelope className={style.icon} />
					</a>
					<a className={style.a} href="tel:+91 8884264377">
						<FaPhoneAlt className={style.icon} />
					</a>
				</div>
			) : null}
			<div className={style.row}>
				{showCon === true ? (
					<div className={style.row1}>
						<p className={style.pCon}>Contact Us</p>
						<FaChevronRight size={12} color="black" />
					</div>
				) : null}
				<div
					className={style.barDiv}
					onClick={() => {
						setShow(!show);
						setShowCon(false);
					}}
				>
					{show === false ? (
						<FaBars className={style.bars} />
					) : (
						<FaTimes className={style.times} />
					)}
				</div>
			</div>
		</div>
	);
}

export default Pop;
